/**
 * 訂單查詢範圍
 *
 * 對應後端的 `OrderQueryScopeEnum`
 *
 * - {@link OrderQueryScopeEnum.personal} 個人訂單
 * - {@link OrderQueryScopeEnum.includeDepartment} 包含部門訂單
 * - {@link OrderQueryScopeEnum.all} 全部訂單
 * - {@link OrderQueryScopeEnum.urgent} 急件
 * - {@link OrderQueryScopeEnum.overdue} 逾期訂單
 */
export enum OrderQueryScopeEnum {
  personal = 'PERSONAL',
  includeDepartment = 'INCLUDE_DEPARTMENT',
  all = 'ALL',
  urgent = 'URGENT',
  overdue = 'OVERDUE'
}
